/**
 * Comprehensive Country and State/Province data
 * Used across all address forms in the application
 */

export const COUNTRIES = [
  // North America
  { value: 'US', label: 'United States' },
  { value: 'CA', label: 'Canada' },
  { value: 'MX', label: 'Mexico' },
  
  // Europe
  { value: 'GB', label: 'United Kingdom' },
  { value: 'DE', label: 'Germany' },
  { value: 'FR', label: 'France' },
  { value: 'IT', label: 'Italy' },
  { value: 'ES', label: 'Spain' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'BE', label: 'Belgium' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'AT', label: 'Austria' },
  { value: 'SE', label: 'Sweden' },
  { value: 'NO', label: 'Norway' },
  { value: 'DK', label: 'Denmark' },
  { value: 'FI', label: 'Finland' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'IE', label: 'Ireland' },
  { value: 'GR', label: 'Greece' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'RO', label: 'Romania' },
  { value: 'HU', label: 'Hungary' },
  
  // Asia Pacific
  { value: 'IN', label: 'India' },
  { value: 'CN', label: 'China' },
  { value: 'JP', label: 'Japan' },
  { value: 'KR', label: 'South Korea' },
  { value: 'SG', label: 'Singapore' },
  { value: 'AU', label: 'Australia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'TH', label: 'Thailand' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'PH', label: 'Philippines' },
  { value: 'VN', label: 'Vietnam' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'NP', label: 'Nepal' },
  
  // Middle East
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'QA', label: 'Qatar' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'OM', label: 'Oman' },
  { value: 'IL', label: 'Israel' },
  { value: 'TR', label: 'Turkey' },
  
  // Africa
  { value: 'ZA', label: 'South Africa' },
  { value: 'EG', label: 'Egypt' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'KE', label: 'Kenya' },
  { value: 'MA', label: 'Morocco' },
  { value: 'GH', label: 'Ghana' },
  
  // South America
  { value: 'BR', label: 'Brazil' },
  { value: 'AR', label: 'Argentina' },
  { value: 'CL', label: 'Chile' },
  { value: 'CO', label: 'Colombia' },
  { value: 'PE', label: 'Peru' },
  { value: 'VE', label: 'Venezuela' },
];

export const STATES_BY_COUNTRY = {
  // United States - All 50 States + DC
  'US': [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California',
    'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida',
    'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana',
    'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine',
    'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
    'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
    'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
    'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island',
    'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah',
    'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
  ],
  
  // Canada - All Provinces and Territories
  'CA': [
    'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick',
    'Newfoundland and Labrador', 'Northwest Territories', 'Nova Scotia',
    'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon'
  ],
  
  // Mexico
  'MX': [
    'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche',
    'Chiapas', 'Chihuahua', 'Coahuila', 'Colima', 'Durango',
    'Guanajuato', 'Guerrero', 'Hidalgo', 'Jalisco', 'Mexico City',
    'Mexico State', 'Michoacán', 'Morelos', 'Nayarit', 'Nuevo León',
    'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí',
    'Sinaloa', 'Sonora', 'Tabasco', 'Tamaulipas', 'Tlaxcala',
    'Veracruz', 'Yucatán', 'Zacatecas'
  ],
  
  // United Kingdom
  'GB': [
    'England', 'Scotland', 'Wales', 'Northern Ireland',
    // Major English regions/counties
    'Greater London', 'West Midlands', 'Greater Manchester', 'West Yorkshire',
    'Merseyside', 'South Yorkshire', 'Tyne and Wear', 'Kent', 'Essex',
    'Hampshire', 'Surrey', 'Hertfordshire', 'Lancashire', 'Nottinghamshire'
  ],
  
  // Germany - All States
  'DE': [
    'Baden-Württemberg', 'Bavaria', 'Berlin', 'Brandenburg', 'Bremen',
    'Hamburg', 'Hesse', 'Lower Saxony', 'Mecklenburg-Vorpommern',
    'North Rhine-Westphalia', 'Rhineland-Palatinate', 'Saarland',
    'Saxony', 'Saxony-Anhalt', 'Schleswig-Holstein', 'Thuringia'
  ],
  
  // France - Regions
  'FR': [
    'Auvergne-Rhône-Alpes', 'Bourgogne-Franche-Comté', 'Brittany',
    'Centre-Val de Loire', 'Corsica', 'Grand Est', 'Hauts-de-France',
    'Île-de-France', 'Normandy', 'Nouvelle-Aquitaine', 'Occitanie',
    'Pays de la Loire', 'Provence-Alpes-Côte d\'Azur'
  ],
  
  // Italy - Regions
  'IT': [
    'Abruzzo', 'Aosta Valley', 'Apulia', 'Basilicata', 'Calabria',
    'Campania', 'Emilia-Romagna', 'Friuli-Venezia Giulia', 'Lazio',
    'Liguria', 'Lombardy', 'Marche', 'Molise', 'Piedmont',
    'Sardinia', 'Sicily', 'Trentino-Alto Adige', 'Tuscany', 'Umbria', 'Veneto'
  ],
  
  // Spain - Autonomous Communities
  'ES': [
    'Andalusia', 'Aragon', 'Asturias', 'Balearic Islands', 'Basque Country',
    'Canary Islands', 'Cantabria', 'Castile and León', 'Castile-La Mancha',
    'Catalonia', 'Extremadura', 'Galicia', 'La Rioja', 'Madrid',
    'Murcia', 'Navarre', 'Valencia'
  ],
  
  // India - All States and Union Territories
  'IN': [
    'Andaman and Nicobar Islands', 'Andhra Pradesh', 'Arunachal Pradesh',
    'Assam', 'Bihar', 'Chandigarh', 'Chhattisgarh', 'Dadra and Nagar Haveli and Daman and Diu',
    'Delhi', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh',
    'Jammu and Kashmir', 'Jharkhand', 'Karnataka', 'Kerala', 'Ladakh',
    'Lakshadweep', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya',
    'Mizoram', 'Nagaland', 'Odisha', 'Puducherry', 'Punjab',
    'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
    'Uttar Pradesh', 'Uttarakhand', 'West Bengal'
  ],
  
  // China - Provinces
  'CN': [
    'Anhui', 'Beijing', 'Chongqing', 'Fujian', 'Gansu',
    'Guangdong', 'Guangxi', 'Guizhou', 'Hainan', 'Hebei',
    'Heilongjiang', 'Henan', 'Hong Kong SAR', 'Hubei', 'Hunan',
    'Inner Mongolia', 'Jiangsu', 'Jiangxi', 'Jilin', 'Liaoning',
    'Macau SAR', 'Ningxia', 'Qinghai', 'Shaanxi', 'Shandong',
    'Shanghai', 'Shanxi', 'Sichuan', 'Tianjin', 'Tibet',
    'Xinjiang', 'Yunnan', 'Zhejiang'
  ],
  
  // Japan - Prefectures
  'JP': [
    'Aichi', 'Akita', 'Aomori', 'Chiba', 'Ehime', 'Fukui',
    'Fukuoka', 'Fukushima', 'Gifu', 'Gunma', 'Hiroshima', 'Hokkaido',
    'Hyogo', 'Ibaraki', 'Ishikawa', 'Iwate', 'Kagawa', 'Kagoshima',
    'Kanagawa', 'Kochi', 'Kumamoto', 'Kyoto', 'Mie', 'Miyagi',
    'Miyazaki', 'Nagano', 'Nagasaki', 'Nara', 'Niigata', 'Oita',
    'Okayama', 'Okinawa', 'Osaka', 'Saga', 'Saitama', 'Shiga',
    'Shimane', 'Shizuoka', 'Tochigi', 'Tokushima', 'Tokyo', 'Tottori',
    'Toyama', 'Wakayama', 'Yamagata', 'Yamaguchi', 'Yamanashi'
  ],
  
  // Australia - States and Territories
  'AU': [
    'Australian Capital Territory', 'New South Wales', 'Northern Territory',
    'Queensland', 'South Australia', 'Tasmania', 'Victoria', 'Western Australia'
  ],
  
  // New Zealand - Regions
  'NZ': [
    'Auckland', 'Bay of Plenty', 'Canterbury', 'Gisborne', 'Hawke\'s Bay',
    'Manawatu-Whanganui', 'Marlborough', 'Nelson', 'Northland', 'Otago',
    'Southland', 'Taranaki', 'Tasman', 'Waikato', 'Wellington', 'West Coast'
  ],
  
  // Singapore (City-State - no states)
  'SG': ['Central Region', 'East Region', 'North Region', 'North-East Region', 'West Region'],
  
  // Malaysia - States
  'MY': [
    'Johor', 'Kedah', 'Kelantan', 'Kuala Lumpur', 'Labuan',
    'Melaka', 'Negeri Sembilan', 'Pahang', 'Penang', 'Perak',
    'Perlis', 'Putrajaya', 'Sabah', 'Sarawak', 'Selangor', 'Terengganu'
  ],
  
  // Thailand - Provinces (major ones)
  'TH': [
    'Bangkok', 'Chiang Mai', 'Chiang Rai', 'Chonburi', 'Khon Kaen',
    'Nakhon Ratchasima', 'Nonthaburi', 'Pathum Thani', 'Phuket',
    'Samut Prakan', 'Songkhla', 'Surat Thani', 'Udon Thani'
  ],
  
  // Indonesia - Provinces (major ones)
  'ID': [
    'Bali', 'Banten', 'Central Java', 'East Java', 'Jakarta',
    'North Sumatra', 'South Sulawesi', 'West Java', 'West Sumatra', 'Yogyakarta'
  ],
  
  // Philippines - Regions
  'PH': [
    'Bicol Region', 'CALABARZON', 'Cagayan Valley', 'Caraga',
    'Central Luzon', 'Central Visayas', 'Cordillera Administrative Region',
    'Davao Region', 'Eastern Visayas', 'Ilocos Region', 'Metro Manila',
    'MIMAROPA', 'Northern Mindanao', 'Soccsksargen', 'Western Visayas', 'Zamboanga Peninsula'
  ],
  
  // Vietnam - Regions
  'VN': [
    'Central Highlands', 'Hanoi', 'Ho Chi Minh City', 'Mekong Delta',
    'North Central Coast', 'Northeast', 'Northwest', 'Red River Delta',
    'South Central Coast', 'Southeast'
  ],
  
  // South Korea - Provinces
  'KR': [
    'Busan', 'Chungcheongbuk-do', 'Chungcheongnam-do', 'Daegu', 'Daejeon',
    'Gangwon-do', 'Gwangju', 'Gyeonggi-do', 'Gyeongsangbuk-do', 'Gyeongsangnam-do',
    'Incheon', 'Jeju', 'Jeollabuk-do', 'Jeollanam-do', 'Sejong', 'Seoul', 'Ulsan'
  ],
  
  // Hong Kong (City - districts)
  'HK': ['Hong Kong Island', 'Kowloon', 'New Territories'],
  
  // Taiwan - Counties
  'TW': [
    'Changhua County', 'Chiayi City', 'Chiayi County', 'Hsinchu City',
    'Hsinchu County', 'Hualien County', 'Kaohsiung', 'Keelung',
    'Miaoli County', 'Nantou County', 'New Taipei', 'Penghu County',
    'Pingtung County', 'Taichung', 'Tainan', 'Taipei', 'Taitung County',
    'Taoyuan', 'Yilan County', 'Yunlin County'
  ],
  
  // Pakistan - Provinces
  'PK': [
    'Azad Kashmir', 'Balochistan', 'Gilgit-Baltistan', 'Islamabad Capital Territory',
    'Khyber Pakhtunkhwa', 'Punjab', 'Sindh'
  ],
  
  // Bangladesh - Divisions
  'BD': [
    'Barishal', 'Chattogram', 'Dhaka', 'Khulna', 'Mymensingh',
    'Rajshahi', 'Rangpur', 'Sylhet'
  ],
  
  // Sri Lanka - Provinces
  'LK': [
    'Central', 'Eastern', 'North Central', 'Northern', 'North Western',
    'Sabaragamuwa', 'Southern', 'Uva', 'Western'
  ],
  
  // Nepal - Provinces
  'NP': [
    'Bagmati', 'Gandaki', 'Karnali', 'Koshi', 'Lumbini', 'Madhesh', 'Sudurpashchim'
  ],
  
  // United Arab Emirates - Emirates
  'AE': [
    'Abu Dhabi', 'Ajman', 'Dubai', 'Fujairah', 'Ras Al Khaimah', 'Sharjah', 'Umm Al Quwain'
  ],
  
  // Saudi Arabia - Regions
  'SA': [
    'Al Bahah', 'Al Jawf', 'Al Madinah', 'Al Qassim', 'Asir',
    'Eastern Province', 'Ha\'il', 'Jazan', 'Makkah', 'Najran',
    'Northern Borders', 'Riyadh', 'Tabuk'
  ],
  
  // Qatar (City-state)
  'QA': ['Al Daayen', 'Al Khor', 'Al Rayyan', 'Al Shamal', 'Al Wakrah', 'Doha', 'Madinat ash Shamal', 'Umm Salal'],
  
  // Kuwait - Governorates
  'KW': ['Ahmadi', 'Capital', 'Farwaniya', 'Hawalli', 'Jahra', 'Mubarak Al-Kabeer'],
  
  // Bahrain - Governorates
  'BH': ['Capital', 'Muharraq', 'Northern', 'Southern'],
  
  // Oman - Governorates
  'OM': [
    'Ad Dakhiliyah', 'Ad Dhahirah', 'Al Batinah North', 'Al Batinah South',
    'Al Buraimi', 'Al Wusta', 'Ash Sharqiyah North', 'Ash Sharqiyah South',
    'Dhofar', 'Musandam', 'Muscat'
  ],
  
  // Israel - Districts
  'IL': ['Central', 'Haifa', 'Jerusalem', 'Northern', 'Southern', 'Tel Aviv'],
  
  // Turkey - Regions
  'TR': [
    'Aegean Region', 'Black Sea Region', 'Central Anatolia', 'Eastern Anatolia',
    'Istanbul', 'Marmara Region', 'Mediterranean Region', 'Southeastern Anatolia'
  ],
  
  // South Africa - Provinces
  'ZA': [
    'Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo',
    'Mpumalanga', 'North West', 'Northern Cape', 'Western Cape'
  ],
  
  // Egypt - Governorates (major ones)
  'EG': [
    'Alexandria', 'Aswan', 'Asyut', 'Cairo', 'Dakahlia', 'Faiyum',
    'Gharbia', 'Giza', 'Ismailia', 'Kafr El Sheikh', 'Luxor', 'Port Said',
    'Qalyubia', 'Sharqia', 'Suez'
  ],
  
  // Nigeria - States
  'NG': [
    'Abia', 'Abuja', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi',
    'Bayelsa', 'Benue', 'Borno', 'Cross River', 'Delta', 'Ebonyi',
    'Edo', 'Ekiti', 'Enugu', 'Gombe', 'Imo', 'Jigawa', 'Kaduna',
    'Kano', 'Katsina', 'Kebbi', 'Kogi', 'Kwara', 'Lagos', 'Nasarawa',
    'Niger', 'Ogun', 'Ondo', 'Osun', 'Oyo', 'Plateau', 'Rivers',
    'Sokoto', 'Taraba', 'Yobe', 'Zamfara'
  ],
  
  // Kenya - Counties (major ones)
  'KE': [
    'Kiambu', 'Kisumu', 'Machakos', 'Mombasa', 'Nairobi', 'Nakuru', 'Nyeri'
  ],
  
  // Morocco - Regions
  'MA': [
    'Béni Mellal-Khénifra', 'Casablanca-Settat', 'Drâa-Tafilalet',
    'Fès-Meknès', 'Guelmim-Oued Noun', 'Laâyoune-Sakia El Hamra',
    'Marrakech-Safi', 'Oriental', 'Rabat-Salé-Kénitra', 'Souss-Massa',
    'Tanger-Tétouan-Al Hoceïma'
  ],
  
  // Ghana - Regions
  'GH': [
    'Ahafo', 'Ashanti', 'Bono', 'Bono East', 'Central', 'Eastern',
    'Greater Accra', 'North East', 'Northern', 'Oti', 'Savannah',
    'Upper East', 'Upper West', 'Volta', 'Western', 'Western North'
  ],
  
  // Brazil - States
  'BR': [
    'Acre', 'Alagoas', 'Amapá', 'Amazonas', 'Bahia', 'Ceará',
    'Distrito Federal', 'Espírito Santo', 'Goiás', 'Maranhão',
    'Mato Grosso', 'Mato Grosso do Sul', 'Minas Gerais', 'Pará',
    'Paraíba', 'Paraná', 'Pernambuco', 'Piauí', 'Rio de Janeiro',
    'Rio Grande do Norte', 'Rio Grande do Sul', 'Rondônia', 'Roraima',
    'Santa Catarina', 'São Paulo', 'Sergipe', 'Tocantins'
  ],
  
  // Argentina - Provinces
  'AR': [
    'Buenos Aires', 'Catamarca', 'Chaco', 'Chubut', 'Córdoba',
    'Corrientes', 'Entre Ríos', 'Formosa', 'Jujuy', 'La Pampa',
    'La Rioja', 'Mendoza', 'Misiones', 'Neuquén', 'Río Negro',
    'Salta', 'San Juan', 'San Luis', 'Santa Cruz', 'Santa Fe',
    'Santiago del Estero', 'Tierra del Fuego', 'Tucumán'
  ],
  
  // Chile - Regions
  'CL': [
    'Aisén', 'Antofagasta', 'Araucanía', 'Arica y Parinacota',
    'Atacama', 'Biobío', 'Coquimbo', 'Los Lagos', 'Los Ríos',
    'Magallanes', 'Maule', 'Ñuble', 'O\'Higgins', 'Santiago Metropolitan',
    'Tarapacá', 'Valparaíso'
  ],
  
  // Colombia - Departments (major ones)
  'CO': [
    'Antioquia', 'Atlántico', 'Bogotá D.C.', 'Bolívar', 'Boyacá',
    'Caldas', 'Cundinamarca', 'Nariño', 'Norte de Santander',
    'Risaralda', 'Santander', 'Tolima', 'Valle del Cauca'
  ],
  
  // Peru - Departments (major ones)
  'PE': [
    'Arequipa', 'Callao', 'Cusco', 'Ica', 'Junín', 'La Libertad',
    'Lambayeque', 'Lima', 'Loreto', 'Piura', 'Puno'
  ],
  
  // Venezuela - States (major ones)
  'VE': [
    'Aragua', 'Bolívar', 'Carabobo', 'Caracas', 'Lara',
    'Miranda', 'Táchira', 'Zulia'
  ],
  
  // Netherlands - Provinces
  'NL': [
    'Drenthe', 'Flevoland', 'Friesland', 'Gelderland', 'Groningen',
    'Limburg', 'North Brabant', 'North Holland', 'Overijssel',
    'South Holland', 'Utrecht', 'Zeeland'
  ],
  
  // Belgium - Regions
  'BE': ['Brussels-Capital Region', 'Flanders', 'Wallonia'],
  
  // Switzerland - Cantons
  'CH': [
    'Aargau', 'Appenzell Ausserrhoden', 'Appenzell Innerrhoden',
    'Basel-Landschaft', 'Basel-Stadt', 'Bern', 'Fribourg', 'Geneva',
    'Glarus', 'Graubünden', 'Jura', 'Lucerne', 'Neuchâtel', 'Nidwalden',
    'Obwalden', 'Schaffhausen', 'Schwyz', 'Solothurn', 'St. Gallen',
    'Thurgau', 'Ticino', 'Uri', 'Valais', 'Vaud', 'Zug', 'Zürich'
  ],
  
  // Austria - States
  'AT': [
    'Burgenland', 'Carinthia', 'Lower Austria', 'Salzburg',
    'Styria', 'Tyrol', 'Upper Austria', 'Vienna', 'Vorarlberg'
  ],
  
  // Sweden - Counties
  'SE': [
    'Blekinge', 'Dalarna', 'Gävleborg', 'Gotland', 'Halland',
    'Jämtland', 'Jönköping', 'Kalmar', 'Kronoberg', 'Norrbotten',
    'Örebro', 'Östergötland', 'Skåne', 'Södermanland', 'Stockholm',
    'Uppsala', 'Värmland', 'Västerbotten', 'Västernorrland',
    'Västmanland', 'Västra Götaland'
  ],
  
  // Norway - Counties
  'NO': [
    'Agder', 'Innlandet', 'Møre og Romsdal', 'Nordland',
    'Oslo', 'Rogaland', 'Troms og Finnmark', 'Trøndelag',
    'Vestfold og Telemark', 'Vestland', 'Viken'
  ],
  
  // Denmark - Regions
  'DK': [
    'Capital Region', 'Central Denmark', 'North Denmark',
    'South Denmark', 'Zealand'
  ],
  
  // Finland - Regions
  'FI': [
    'Central Finland', 'Central Ostrobothnia', 'Kainuu',
    'Kymenlaakso', 'Lapland', 'North Karelia', 'North Ostrobothnia',
    'North Savo', 'Ostrobothnia', 'Päijät-Häme', 'Pirkanmaa',
    'Satakunta', 'South Karelia', 'South Ostrobothnia', 'South Savo',
    'Southwest Finland', 'Tavastia Proper', 'Uusimaa'
  ],
  
  // Poland - Voivodeships
  'PL': [
    'Greater Poland', 'Kuyavian-Pomeranian', 'Lesser Poland',
    'Łódź', 'Lower Silesian', 'Lublin', 'Lubusz', 'Masovian',
    'Opole', 'Podkarpackie', 'Podlaskie', 'Pomeranian',
    'Silesian', 'Świętokrzyskie', 'Warmian-Masurian', 'West Pomeranian'
  ],
  
  // Portugal - Districts
  'PT': [
    'Aveiro', 'Beja', 'Braga', 'Bragança', 'Castelo Branco',
    'Coimbra', 'Évora', 'Faro', 'Guarda', 'Leiria', 'Lisbon',
    'Portalegre', 'Porto', 'Santarém', 'Setúbal', 'Viana do Castelo',
    'Vila Real', 'Viseu'
  ],
  
  // Ireland - Provinces/Counties
  'IE': [
    'Carlow', 'Cavan', 'Clare', 'Cork', 'Donegal', 'Dublin',
    'Galway', 'Kerry', 'Kildare', 'Kilkenny', 'Laois', 'Leitrim',
    'Limerick', 'Longford', 'Louth', 'Mayo', 'Meath', 'Monaghan',
    'Offaly', 'Roscommon', 'Sligo', 'Tipperary', 'Waterford',
    'Westmeath', 'Wexford', 'Wicklow'
  ],
  
  // Greece - Regions
  'GR': [
    'Attica', 'Central Greece', 'Central Macedonia', 'Crete',
    'East Macedonia and Thrace', 'Epirus', 'Ionian Islands',
    'North Aegean', 'Peloponnese', 'South Aegean', 'Thessaly',
    'West Greece', 'West Macedonia'
  ],
  
  // Czech Republic - Regions
  'CZ': [
    'Central Bohemian', 'Hradec Králové', 'Karlovy Vary', 'Liberec',
    'Moravian-Silesian', 'Olomouc', 'Pardubice', 'Plzeň',
    'Prague', 'South Bohemian', 'South Moravian', 'Ústí nad Labem',
    'Vysočina', 'Zlín'
  ],
  
  // Romania - Counties (major ones)
  'RO': [
    'Brașov', 'Bucharest', 'Cluj', 'Constanța', 'Dolj',
    'Galați', 'Iași', 'Ilfov', 'Prahova', 'Timiș'
  ],
  
  // Hungary - Counties
  'HU': [
    'Bács-Kiskun', 'Baranya', 'Békés', 'Borsod-Abaúj-Zemplén',
    'Budapest', 'Csongrád-Csanád', 'Fejér', 'Győr-Moson-Sopron',
    'Hajdú-Bihar', 'Heves', 'Jász-Nagykun-Szolnok', 'Komárom-Esztergom',
    'Nógrád', 'Pest', 'Somogy', 'Szabolcs-Szatmár-Bereg', 'Tolna',
    'Vas', 'Veszprém', 'Zala'
  ],
};

/**
 * Get states/provinces for a given country code
 * @param {string} countryCode - The country code (e.g., 'US', 'IN')
 * @returns {string[]} Array of state/province names
 */
export const getStatesForCountry = (countryCode) => {
  return STATES_BY_COUNTRY[countryCode] || [];
};

/**
 * Get country label by code
 * @param {string} countryCode - The country code
 * @returns {string} The country label or the code if not found
 */
export const getCountryLabel = (countryCode) => {
  const country = COUNTRIES.find(c => c.value === countryCode);
  return country ? country.label : countryCode;
};

export default {
  COUNTRIES,
  STATES_BY_COUNTRY,
  getStatesForCountry,
  getCountryLabel
};
